import { ServiceCategory } from '@prisma/client';
import { convertSnakeToTitleCase } from '../../utils/global/helper';
import { trimString } from '../global';
import { LoadedUser } from '../../interfaces';

export const getServiceDescriptionLabel = (
  serviceCategory: ServiceCategory | null | undefined,
) => {
  if (
    !serviceCategory ||
    serviceCategory === 'OTHER' ||
    serviceCategory === 'SPA'
  ) {
    return 'service';
  }

  return convertSnakeToTitleCase(serviceCategory).toLowerCase();
};

export function getServiceLabel(
  serviceCategory: string | null | undefined,
  serviceName: string | null | undefined,
  useServiceName = false,
): string {
  const trimmedServiceName = trimString(serviceName ?? 'Other', 20);
  const category = serviceCategory || 'TATTOO';
  if (category === 'OTHER' || useServiceName) {
    return trimmedServiceName;
  }
  return convertSnakeToTitleCase(category);
}

export const getAllUserServices = (user: LoadedUser | null) => {
  if (!user?.allBusinesses?.length) return [];

  return user.allBusinesses.flatMap(business => business.services ?? []);
};
